import { render, staticRenderFns } from "./PedidoForm.vue?vue&type=template&id=53a92327&"
import script from "./PedidoForm.vue?vue&type=script&lang=js&"
export * from "./PedidoForm.vue?vue&type=script&lang=js&"
import style0 from "./PedidoForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PedidoForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports